const ConstitutionComponent = () => {
  return (
    <>
      <h3 id="article_1name_of_the_society" className="sectionedit2">
        Article 1: Name of the Society
      </h3>
      <div className="level3">
        <p>
          1.1 The name of the Society shall be Compsoc, University of Galway,
          hereinafter referred to as &ldquo;the Society&rdquo;.
        </p>
        <p>
          1.3 The Society exists as a constituent part of the University and is
          therefore subject to all relevant University and University Societies
          Coordination Group (USCG) policies and rules.
        </p>
      </div>

      <h3
        id="article_2alliances_affiliations_with_external_bodies"
        className="sectionedit3"
      >
        Article 2: Alliances/Affiliations with External bodies
      </h3>
      <div className="level3">
        <p>
          2.1 The Society is not aligned and/or affiliated with any external
          bodies.
        </p>
        <p>
          2.2 The Society is a constituent part of the University and where
          there are alliances and affiliations with external bodies the Society
          is subject to the USCG Society policy on external affiliation as may
          be updated from time to time.
        </p>
      </div>

      <h3 id="article_3aims_of_the_society" className="sectionedit4">
        Article 3: Aims of the Society
      </h3>
      <div className="level3">
        <p>The aims of the Society shall be:</p>
        <ul>
          <li>
            To provide a social space for students interested in computing.
          </li>
          <li>
            To provide opportunities for members to expand their knowledge about
            computers, IT, programming, or related disciplines.
          </li>
          <li>To provide services to members such as hosting projects.</li>
        </ul>
      </div>

      <h3 id="article_4membership" className="sectionedit5">
        Article 4: Membership
      </h3>
      <div className="level3">
        <p>
          4.1 All current students and current staff of the University shall be
          eligible to become full members of the Society.
        </p>
        <p>
          4.1.1 Students and Staff may be prohibited from being a member where
          they have been subject to a USCG or University sanction prohibiting
          them from such.
        </p>
        <p>
          4.2 Any eligible person shall become a member of the Society upon
          registering with the Society on any Societies&rsquo; Day, or using the
          official society&rsquo;s registration, and payment of appropriate fee
          if applicable.
        </p>
        <p>
          4.2.1 Should the Society charge a membership fee, full membership
          shall be granted upon payment of said fee. The fee shall be determined
          by the Committee annually, subject to the approval of the Societies
          Office. All such monies thus received must be lodged in full to the
          Society&rsquo;s bank account.
        </p>
        <p>
          4.2.2 Should the Society be affiliated with a body that charges a
          membership fee, members are not obliged to join the external body and
          therefore not obliged to pay the membership fee.
        </p>
        <p>
          4.3 The Society may, subject to approval of the USCG, elect any member
          or alumni who they deem to have done great service for the Society to
          be an Honorary Life Member (HLM) in perpetuity of the Society.
        </p>
        <p>
          4.3.1 An HLM is entitled to entry to Society events and speaking
          rights at regular meetings, but is not entitled to a vote at regular
          meetings or Annual General Meeting (AGM) / Extraordinary General
          Meeting (EGM), and is also not entitled to stand for a committee
          position or any other privileges open to full members.
        </p>
        <p>
          4.3.2 If an HLM becomes eligible for full membership as per article
          4.1 he/she shall have the same privileges as a full member.
        </p>
      </div>

      <h3 id="article_5the_committee" className="sectionedit6">
        Article 5: The Committee
      </h3>
      <div className="level3">
        <p>5.1 A Committee shall conduct the business of the Society.</p>
        <p>
          5.2 All members of the Committee shall be required to be full members
          of the Society.
        </p>
        <p>
          5.3 All full members of the Society are eligible to be elected to the
          Committee except those explicitly disallowed hereinafter.
        </p>
        <p>
          5.3.1 Full members are ineligible to stand for election and/or act as
          a member of the Committee where they have been subject to a USCG or
          University sanction prohibiting them from doing so.
        </p>
        <p>
          5.4 The Committee shall consist of the core members specified in
          Article 5.5, additional specified committee members specified in
          Article 5.6.2, and ordinary Committee members as specified in article
          5.7
        </p>
        <p>5.5 Core Positions</p>
        <p>
          The core positions are Auditor, Vice-Auditor, Treasurer, and
          Secretary. The Committee must consist of at least these four
          positions.
        </p>
        <p>5.5.1 Auditor</p>
        <p>
          The Auditor shall have overall responsibility for the affairs of the
          Society. The Auditor shall chair all meetings of the Society save
          where otherwise provided for in this Constitution. The Auditors shall
          facilitate the running of the society by the committee. The Auditor
          has ultimate responsibility of ensuring that all Society requirements
          are fulfilled.
        </p>
        <p>
          5.5.1.1 The Auditor in the cases of all votes shall be eligible to
          vote. In the case of a tie, the Auditor may use his/her casting vote
          thereafter to decide the tie, except as provided for in Article 9.2.
          This may or may not be in accordance with his/her original vote.
        </p>
        <p>5.5.2 Vice-Auditor</p>
        <p>
          The Vice Auditor must assist the Auditor in the general running of the
          Society. The Vice-Auditor shall assume the duties of the Auditor
          should the Auditor be absent or unable to fulfil his/her duties. The
          Vice-Auditor may fulfil any general role as defined by the Committee.
        </p>
        <p>5.5.3 Treasurer</p>
        <p>
          The Treasurer will manage the financial affairs of the Society, in
          consultation with the Auditor & the Committee. The Treasurer will
          maintain the financial records of the Society. He/she will prepare and
          present a Treasurer’s Report to the Society at the AGM. The Treasurer
          must prepare and present the end of year financial report, and all
          accounts as required by the Societies Office, in accordance with the
          deadline stated by the Societies Office.
        </p>
        <p>5.5.4 Secretary</p>
        <p>
          The Secretary shall keep the non-financial records of the Society, and
          shall submit the end of year report. The Secretary is responsible for
          ensuring that all events are posted to the Societies Calendar. The
          Secretary shall manage the correspondence of the Society. The
          Secretary is also tasked with taking minutes of all Committee
          meetings, general meetings, AGM(s) & EGM(s) during his/her term of
          office.
        </p>
        <p>5.6 Additional Specified Committee Members</p>
        <p>
          The Society may create Additional Specified Committee Members (ASCMs).
          ASCMs of the Society are listed and described in article 5.6.2 and its
          sub-articles respectively. Where the Society wishes to create, modify
          or remove an ASCM, it will be done by means of an Amendment to Article
          5.6.2 which shall also create, modify or remove a sub-article
          respectively to effect this change.
        </p>
        <p>
          5.6.1 In cases hereinafter where it is explicitly stated that an ASCM
          may be co-opted, the Society may vote to allow the duties and title of
          an ASCM position may be co-opted by the Committee to a member of the
          Committee.
        </p>
        <p>
          5.6.2 The following ASCMs will be elected/appointed to the Committee;
          Public Relations Officer, Health and Safety Officer, First Year
          Representative, Post-graduate Representative, Chief System
          Administrator, System Administrator, Junior System Administrator, Data
          Protection Officer.
        </p>
        <p>5.6.2.1 Public Relations Officer (PRO)</p>
        <p>
          The PRO shall be responsible for publicising the meetings and events
          of the Society, and shall act as the officer in charge of
          communications between students and the Society. The Public Relations
          officer is also responsible for managing all online profiles of the
          Society.
        </p>
        <p>5.6.2.2 Health and Safety Officer (HSO)</p>
        <p>
          The HSO will have responsibility for ensuring compliance with
          Societies' Safety Procedures and Policies, as set out by The SocsBox,
          USCG and the University. This position can be co-opted into the role
          of Vice-Auditor unless deemed absolutely necessary by the committee.
        </p>
        <p>5.6.2.3 First Year Representative (FYR)</p>
        <p>
          The FYR is responsible for representing First Year members at Society
          meetings and acting in their best interests at Committee meetings. The
          FYR is also responsible for ensuring events are inclusive to First
          Year students.
        </p>
        <p>5.6.2.4 Post-Graduate Representative (PGR)</p>
        <p>
          The PGR is responsible for representing post-graduate members at
          Society meetings and acting in their best interests at Committee
          meetings. The PGR is also responsible for ensuring events are
          inclusive to post-graduate students.
        </p>
        <p>5.6.2.5 Chief System Administrator</p>
        <p>
          The Chief System Administrator shall be held ultimately responsible
          for the administration, security, and maintenance of the society's
          computer systems. They shall be responsible for the notification of
          the committee regarding any breaches of the rules and regulations of
          the system. They are hereby authorised to take any administrative
          action necessary to discharge their duties, so long as such actions
          are constitutional. Such actions are open to review by the committee.
          The Society may, decide to coopt this position as per article 5.6.1.
        </p>
        <p>5.6.2.6 System Administrator</p>
        <p>
          The System Administrator(s) shall be held ultimately responsible for
          the administration, security, and maintenance of the society’s
          computer systems. They are hereby authorised to take any
          administrative action necessary to discharge their duties, so long as
          such actions are constitutional. Such actions are open to review by
          the committee. The System Administrator(s) will work closely with the
          Senior System Administrator to fairly delegate tasks. The Society may,
          decide to co-opt this position as per article 5.6.1.
        </p>
        <p>5.6.2.8 Data Protection Officer (DPO)</p>
        <p>
          The Data Protection Officer shall be held responsible for ensuring
          that the society processes the personal data of its members, providers
          or any other individuals (also referred to as data subjects) in
          compliance with the applicable data protection rules. They shall train
          the committee on their data protection obligations, conduct audits to
          ensure data protection compliance, and serve as a point of contact for
          any data subject for any queries regarding data processing. They shall
          work independently within the society and report findings/concerns
          directly to the Auditor or Chief System Administrator. They shall not
          co-opt this position if they are already a controller of processing
          activities.
        </p>
        <p>5.7 Ordinary Committee Members</p>
        <p>
          Ordinary Committee Members (OCMs) shall be elected to a maximum of 4,
          at an AGM/EGM. They shall be full Committee members, and will
          contribute to the quorum and will have a vote on the Committee. OCM
          tasks may be allocated as required by the Committee.
        </p>
        <p>5.8 Committee Meetings</p>
        <p>
          5.8.1 Meetings of the Committee shall be held at least 4 times or
          fortnightly during each academic term. All members of the Committee
          shall be entitled to attend and vote at such meetings.
        </p>
        <p>
          5.8.2 The quorum for a meeting of the Committee shall be 50% +
          1Committee members.
        </p>
        <p>
          5.8.3 Meetings of the Committee shall be convened (called) by the
          Auditor or by the Secretary; at least (insert minimum amount of days
          here [no less than three days]) days’ notice of a Committee meeting
          shall be given by the Auditor or Secretary to the members of the
          Committee.
        </p>
        <p>
          5.8.4 Meetings may also be convened at the request of 3 or 50% of the
          Committee, whichever is the larger number, with at least the minimum
          notice period as per
        </p>
        <p>
          5.8.4.1. Failure of the Auditor or Secretary to issue this notice
          within 5 days of receipt of the request by these members in writing
          shall entitle these members to issue said notice to the Committee.
        </p>
        <p>
          5.8.5 All Committee members must be notified by their chosen email and
          or by other means as agreed.
        </p>
        <p>
          5.8.6 Committee members that fail to attend 3 Committee meetings,
          without apologies accepted by the Committee, shall be deemed to have
          resigned.
        </p>
        <p>5.9 Motion of no confidence</p>
        <p>
          A motion of no confidence may be taken about a committee member who is
          deemed to not be fulfilling their role as outlined in the
          constitution, or who is deemed not fit to hold their position for
          other reasons specified and agreed by the committee, or that they make
          decisions that the majority of the committee feel to be detrimental to
          the society. The motion must be proposed and seconded at a first
          meeting where the majority vote must agree to table it for the next
          committee meeting it must be on this meeting's agenda.Both meetings
          must be convened correctly as per the constitution.
        </p>
        <p>5.10 Term of Office of the Committee</p>
        <p>
          The Committee shall hold office for a specific one year term to
          decided and published by USCG annually (Currently July 1st – June 30th
          of the following year).
        </p>
      </div>

      <h3 id="article_6committee_meetings" className="sectionedit7">
        Article 6: Committee Meetings.
      </h3>
      <div className="level3">
        <p>
          6.1 Meetings of the Committee shall be held at least 4 times or
          fortnightly during each academic term. All members of the Committee
          shall be entitled to attend and vote at such meetings.
        </p>
        <p>
          6.2 The quorum for a meeting of the Committee shall be 50% +
          1Committee members.
        </p>
        <p>
          6.3 Meetings of the Committee shall be convened (called) by the
          Auditor or by the Secretary; at least (insert minimum amount of days
          here [no less than three days]) days’ notice of a Committee meeting
          shall be given by the Auditor or Secretary to the members of the
          Committee.
        </p>
        <p>
          6.4 Meetings may also be convened at the request of 3 or 50% of the
          Committee, whichever is the larger number, with at least the minimum
          notice period as per{" "}
        </p>
        <p>
          6.4.1. Failure of the Auditor or Secretary to issue this notice within
          5 days of receipt of the request by these members in writing shall
          entitle these members to issue said notice to the Committee.
        </p>
        <p>
          6.5 All Committee members must be notified by their chosen email and
          by other means as agreed.
        </p>
        <p>
          6.6 Committee members that fail to attend 3 Committee meetings,
          without apologies accepted by the Committee, shall be deemed to have
          resigned.
        </p>
        <p>6.7 Motion of no confidence </p>
        <p>
          A motion of no confidence may be taken about a committee member who
        </p>
        <ol type="i">
          <li>
            is deemed to not be fulfilling their role as outlined in the
            constitution,
          </li>
          <li>
            is deemed not fit to hold their position for other reasons specified
            and agreed by the committee,
          </li>
          <li>
            makes decisions that the majority of the committee feel to be
            detrimental to the society. The motion must be proposed and seconded
            at a first meeting where the majority vote must agree to table it
            for the next committee meeting it must be on this meeting's agenda.
            Both meetings must be convened correctly as per the constitution,
            with reference to the Societies Complaints Procedure. This decision
            is subject to approval from USCG before taking effect.
          </li>
        </ol>
        <p>6.8 Term of Office of the Committee</p>
        <p>
          The Committee shall hold office for a specific one year term to
          decided and published by USCG annually (Currently July 1st – June 30th
          of the following year).
        </p>
      </div>

      <h3 id="article_7standing_orders_of_the_society" className="sectionedit8">
        Article 7: Standing Orders of the Society.
      </h3>
      <div className="level3">
        <p>7.1 The Society has one Standing Order.</p>
        <p>
          7.2 Should the Society have Standing Orders, this Constitution
          supersedes any and all provisions in the Standing Orders and takes
          precedence, if there is conflict.
        </p>
        <p>
          7.3 Should the Society have Standing Orders, the Committee shall
          furnish a copy of the Standings Orders, and must continue to do so for
          any amendments or new articles, to the USCG for approval.
        </p>
        <p>
          7.4 Should the Society have Standing Orders, the Committee shall make
          available the Standing Orders along with its Constitution on its
          official Society profile, viewable to all.
        </p>
        <p>
          7.5 Amendments to the constitution must be filed via the Git version
          control system, to the repository titled “Constitution”, located at
          the official CompSoc GitHub profile (Currently:
          https://github.com/ugcompsoc), via an appropriate Branch and Pull
          Request, within seven days of the amendments being brought to order at
          an EGM or AGM. This requirement applies to both ratified and
          unratified amendments brought to order. Pull Requests should be
          appropriately marked “Merged and Accepted” or “Closed and Denied”
          according to the status of the amendment.
        </p>
      </div>

      <h3 id="article_8annual_general_meetings" className="sectionedit9">
        Article 8: Annual General Meetings
      </h3>
      <div className="level3">
        <p>
          8.1 The Annual General Meeting of the Society shall take place in the
          second semester of the academic year, at a time to be determined by
          the Committee of the Society. The Annual General Meeting must be held
          before the second semester teaching term ends.
        </p>
        <p>
          8.2 No less than six days’ notice of the Annual General Meeting shall
          be given to the Society’s members. The date and time of the AGM shall
          be notified to the Society’s Members. This is done by, at a minimum,
          uploading the date to the Societies Calendar, emailing all members,
          and by other means as agreed.
        </p>
      </div>

      <h3
        id="article_9extraordinary_general_meetings"
        className="sectionedit10"
      >
        Article 9: Extraordinary General Meetings
      </h3>
      <div className="level3">
        <p>
          9.1 An Extraordinary General Meeting of the Society may be convened
          to:
        </p>
        <ol type="i">
          <li>
            Hold an election to fill a vacancy on the Committee, should one
            arise.
          </li>
          <li>
            Consider a proposal to amend this Constitution or any other
            governing instrument of the Society;
          </li>
          <li>
            Address any other circumstance not provided for in this
            Constitution.
          </li>
        </ol>
        <p>9.2 An Extraordinary General Meeting shall be convened:</p>
        <ol type="i">
          <li>By the Auditor or Secretary</li>
          <li>By majority (50% +1) decision of the Committee; or</li>
          <li>
            On foot of a submission to the Societies Office of a petition signed
            by not less than 75 Members of the Society or 33% of the membership,
            whichever is smaller. Only the signatures of Members who are
            eligible to a vote at General Meetings on the date of submission of
            the petition, as per Article 10.2, may be counted towards the quota
            of signatures.
          </li>
        </ol>
        <p>
          9.3 In the case of a resignation or dismissal, or removal as a result
          of a USCG or University sanction, from the Committee of a Committee
          member, the Committee shall have the power to co-opt any full member
          of the Society to the Committee until the next general meeting (be it
          an EGM or an AGM), at which a new officer will be appointed. This must
          be convened within 4 teaching term weeks from the resignation.
        </p>
        <p>
          9.4 No less than six days’ notice of the Extraordinary General Meeting
          shall be given to the Society’s members. The date and time of the EGM
          shall be notified to theSociety’s Members. This is done by, at a
          minimum, uploading the date to the Societies Calendar, emailing all
          members, and by other means as agreed.
        </p>
      </div>

      <h3 id="article_10election_of_the_committee" className="sectionedit11">
        Article 10: Election of the Committee
      </h3>
      <div className="level3">
        <p>
          10.1 The Committee of the Society shall be elected at the Annual
          General Meeting, except where otherwise provided for in this
          Constitution.
        </p>
        <p>
          10.2 The Auditor shall appoint a Returning Officer for elections. The
          Auditor may appoint himself/herself as returning officer. The
          Returning Officer may not be a candidate in any of the elections. The
          Returning Officer must not vote, bar to cast a casting vote in the
          event of a tie. In the event of a tie, the Auditor, where he/she is
          the returning officer, receives a casting vote; in the event where the
          Auditor is not the returning officer, he/she receives no casting vote.
        </p>
        <p>
          10.3 All Members who are eligible to a vote at General Meetings on the
          date of an election, as per Article 10.2, shall be eligible for
          election to the Committee, except as provided for in Article 5.3.
        </p>
        <p>
          10.4 Candidates for each position on the Committee of the Society must
          be proposed and seconded by members of the Society at the AGM. The
          candidates propose themselves.
        </p>
        <p>
          10.5 The election of members of the Committee shall take place by
          secret ballot at the AGM. This, at the discretion the Returning
          Officer with the agreement of two-thirds of the membership attending
          the AGM, may be changed to a show of hands. Should this be implemented
          it is considered to be a change confined to that specific AGM/EGM and
          not be deemed a change to the Constitution.
        </p>
      </div>

      <h3 id="article_11voting_at_general_meetings" className="sectionedit12">
        Article 11: Voting at General Meetings
      </h3>
      <div className="level3">
        <p>
          11.1 Voting shall be by show of hands, unless otherwise determined in
          a vote at any specific meeting.
        </p>
        <p>
          11.2 Full Members of at least 30 days standing of the Society shall be
          entitled to vote in motions at General Meetings. The Secretary must
          present the membership list of those eligible to vote at the election.
          Members who sign-up to the society on Socs day 1 are entitled to vote
          in the first EGM of the year without being members for 30 days.
        </p>
        <p>
          11.3 Motions and resolutions must be passed by a simple majority of
          those Full Members present at the meeting, except where otherwise
          stipulated in this Constitution.
        </p>
      </div>

      <h3
        id="article_12resignations_from_the_committee"
        className="sectionedit13"
      >
        Article 12: Resignations from the Committee
      </h3>
      <div className="level3">
        <p>
          12.1 The resignation of any member of the Committee shall be
          instituted by a letter of resignation to the Secretary of the Society.
        </p>
        <p>
          12.1.1 In the case of the resignation of the Secretary, resignation
          may be instituted by a letter of resignation to the Auditor.
        </p>
        <p>
          12.2 In the case of resignation during term time, the resigning
          Committee member must handover all Society property, passwords and
          handover documents to the committee as per Article 12.1 and, where
          practical, assist with the induction of his/her replacement.
        </p>
      </div>

      <h3 id="article_13handover_documents" className="sectionedit14">
        Article 13: Handover Documents
      </h3>
      <div className="level3">
        <p>
          13.1 Each outgoing officer of the Committee must present Handover
          Documents at the end of his/her term detailing the specific roles and
          responsibilities of their office, and the person(s) with whom he/she
          conducted the business of the Society, in order to assist the incoming
          officer with his/her development of the Society.
        </p>
      </div>

      <h3
        id="article_14instigation_of_disciplinary_action"
        className="sectionedit15"
      >
        Article 14: Instigation of Disciplinary Action
      </h3>
      <div className="level3">
        <p>
          14.1 The Committee and all members of the Society shall comply with
          the disciplinary, grievance, bullying and harassment procedures, and
          all other procedures of the University and the USCG, as may be added
          to or amended from time to time, with reference to the Societies
          Complaints Procedure.
        </p>
        <p>
          14.1.1 Committee members that bring the Society into disrepute may be
          removed by the Committee, with reference to the Societies Complaints
          Procedure. This decision is subject to approval from the USCG before
          taking effect.
        </p>
        <p>
          14.1.2 Society members that bring the Society into disrepute may be
          removed from the membership list by a vote of the Committee, with
          reference to the Societies Complaints Procedure. This decision is
          subject to approval from USCG before taking effect. The following
          constitute some examples of breaches of discipline (but breaches are
          not limited
        </p>
        <p>to the following):</p>
        <ol type="i">
          <li>Serious or persistent breach of Health and Safety.</li>
          <li>Bringing the name of the Society into disrepute.</li>
          <li>Acting against the aims and/or objectives of the Society.</li>
          <li>Misappropriation of any funding relating to the Society.</li>
          <li>Discrimination or Harassment.</li>
          <li>Gross misconduct as interpreted by USCG.</li>
          <li>Breaches of any USCG or University policies or procedures.</li>
        </ol>
      </div>

      <h3 id="article_15management_of_finance" className="sectionedit16">
        Article 15: Management of Finance
      </h3>
      <div className="level3">
        <p>
          15.1 The finances of the Society shall be managed by the Auditor and
          Treasurer of the Society.
        </p>
        <p>
          15.1.1 This Constitution also provides for the possibility of an
          Assistant Treasurer if the Society feels it is necessary.
        </p>
        <p>
          15.2 It is the responsibility of the Treasurer to ensure that all
          monies received from the University and sponsors are receipted through
          the Societies Office.
        </p>
        <p>
          15.3 No Society Member may use their membership for personal financial
          gain. Failure to adhere to this article shall result in University Of
          Galway disciplinary action.
        </p>
      </div>

      <h3
        id="article_16amendments_to_the_constitution"
        className="sectionedit17"
      >
        Article 16: Amendments to the Constitution
      </h3>
      <div className="level3">
        <p>
          16.1 Amendments to this Constitution may be passed at an Annual
          General Meeting or an Extraordinary General Meeting of the Society.
        </p>
        <p>
          16.1.1 The change to the Constitution must be proposed and seconded
          and put to the Vote of the members. A proposed amendment is deemed to
          be passed by a two-Thirds majority of full members present at the
          AGM/EGM.
        </p>
        <p>
          16.2 Such amendments to this Constitution shall require the formal
          ratification of the University Societies Coordination Group before
          taking effect.
        </p>
        <p>
          16.3 The Society must upload their current ratified Constitution to
          its official Society profile.
        </p>
      </div>

      <h3 id="article_17dissolution_of_the_society" className="sectionedit18">
        Article 17: Dissolution of the Society
      </h3>
      <div className="level3">
        <p>
          17.1 The Society may be dissolved by a two-thirds majority vote of its
          membership present at an AGM or EGM.
        </p>
        <p>
          17.2 The Society may fall into abeyance or be dissolved by decision of
          the USCG. The following constitute a non-exhaustive list of grounds
          for abeyance or dissolution.
        </p>
        <ol type="i">
          <li>
            Failure to submit a Treasurer’s Report, submit receipts for all
            University grants and provide information for all transactions at
            the end of the Societies year.
          </li>
          <li>
            Failure to submit a Secretary’s Report at the end of Societies year.
          </li>
          <li>
            Failure to have a table at Societies Day the following
            September.{" "}
          </li>
          <li>
            Failure to elect four core committee members by Society Training
            Weekend.
          </li>
          <li>
            Failure of at least 2 committee members to attend Society Training
            without prior acceptance of apologies to the USCG.
          </li>
        </ol>
        <p>
          17.3 The Society shall fall into abeyance if general activity ceases.
        </p>
        <p>
          17.4 If the Society remains in abeyance for two consecutive years it
          will be deemed to be dissolved.
        </p>
        <p>
          17.5 On dissolution of the Society, all the Societies assets,
          including intellectual property and virtual rights, shall become the
          property of the University.
        </p>
      </div>
    </>
  );
};

export default ConstitutionComponent;
